import React, { Component } from "react";
import { Form, Input, Label, Button } from "../../../Form";

import withTranslations from "../../../../utils/translations/withTranslations";

class HomeDoctor extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="HomeDoctor">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="HomeDoctor__Form"
        >
          <h1>{translate("fiche.home_doctor.title")}</h1>

          <Label text={translate("fiche.home_doctor.first_name")} />
          <Input
            name="first_name"
            rules={["required"]}
            defaultValue={data.first_name}
          />

          <Label text={translate("fiche.home_doctor.last_name")} />
          <Input
            name="last_name"
            rules={["required"]}
            defaultValue={data.last_name}
          />

          <Label text={translate("fiche.home_doctor.city")} />
          <Input
            name="city"
            rules={["required"]}
            defaultValue={data.city}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(HomeDoctor);
